<template>
  <div class="page-box" :style="{display: isMobile.isMobile ? 'block' : 'flex'}">
    <div class="left-box">
      <div class="icon" v-if="subtitle">
        <slot name="icon"></slot>
      </div>
      <div class="custom-heading">{{ heading }}</div>
      <div class="vertical-line" v-if="subtitle">|</div>
      <div class="custom-subtitle">{{ subtitle }}</div>
    </div>
    <div class="content-box">
      <slot name="add"></slot>
    </div>
    <div class="right-box" v-if="addTitle" @click="addClick()">
      <div class="custom-icon"><span class="mdi mdi-plus-thick"></span> </div>
      <div class="custom-addtitle">{{ addTitle }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "commonHeader",
  props: {
    heading: {
      type: String,
      default: "主标题",
    },
    subtitle: {
      type: String,
      default: "",
    },
    addTitle: {
      type: String,
      default: "",
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    addClick() {
      this.$emit('callback')
    },

  }
};

</script>
<style scoped>
.page-box {
  display: flex;
  padding: 15px;
  color: #fff;
  background-color: #4caf50;
  border-radius: 3px;

  .left-box {
    flex: 1;
    display: flex;
    height: 30px;
    line-height: 30px;
    .icon {
      cursor: pointer;
      margin-right: 10px;
    }
    .custom-heading {
      font-size: 20px;
      font-weight: 700;
    }

    .vertical-line {
      display: inline-block;
      margin: 0 10px;
      color: #fff;
    }

    .custom-subtitle {
      font-size: 16px;
      line-height: 32px;
    }

  }
  .content-box {
    padding-top: 4px
  }
  .right-box {
    display: flex;
    color: #fff;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    font-weight: 700;

    .custom-icon {
      margin-right: 3px;
    }

    .custom-addtitle {
      flex: 1;
      line-height: 33px;
    }
  }


}
</style>